import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI_INDEX } from '../../../utils/CmsAPI';
import config from '../../../config';

const reset = createAction(types.ACTION_RESET);
const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const massageData = (response) => {
  const responseData = response.data;
  const fileData = responseData.result.assets.map((file) => {
    return {
      fileName: file.path.split('/').slice(-1)[0].replace('.xml', ''),
      content: file.content.content,
      metadata: file.metadata,
    };
  });
  return {
    lists: fileData,
    total: responseData.total,
  };
};

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const fetchData = (query, start, itemsPerPage, sortBy) => {
  const queryParameters = {
    sortBy: sortBy,
    prefixPath: config.lscsPath,
    q: query,
    start: start,
    max: itemsPerPage,
  };
  const url = CMSAPI_INDEX(queryParameters);

  return axiosAdapter({
    url,
  });
};

const resetIndexPagesList = () => {
  return (dispatch) => {
    dispatch(reset());
  };
};

const getIndexPagesList = (query, start = 0, itemsPerPage, sortBy = '') => {
  return (dispatch) => {
    dispatch(requestFetch({ query, start }));
    return fetchData(query, start, itemsPerPage, sortBy)
      .then((response) => massageData(response))
      .then((data) => {
        dispatch(receiveSuccess(data));
      })
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

export { getIndexPagesList, resetIndexPagesList };
